import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Dropdown, Button } from 'react-bootstrap';
import { IoMdArrowDropdown } from 'react-icons/io';
import i18n from 'i18next';

import PartnerChangeModal from '../../../Modals/PartnerChangeModal/PartnerChangeModal';
import LanguageChangeModal from '../../../Modals/LanguageChangeModal/LanguageChangeModal';

import { logout } from '../../../../actions';

import './UserNav.scss';

function UserNav() {
    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    const user = useSelector(({ user }) => user);
    const [showPartnerChange, setShowPartnerChange] = useState(false);
    const [showLanguageChange, setShowLanguageChange] = useState(false);
    const partnerID = localStorage.getItem('partnerID');
    const userPartners = user.data.partners ? user.data.partners : [];
    const currentPartner = userPartners.length > 0 ? userPartners.find(p => p.partnerID === partnerID) : '';
    const { language } = i18n;

    function _handleLogout() {
        localStorage.removeItem('token');
        dispatch(logout());
        history.replace('/')
    }

    const _openPartnerChangeModal = () => setShowPartnerChange(true);
    const _openLanguageChangeModal = () => setShowLanguageChange(true);

    const _onPartnerClick = (partner) => {
        localStorage.removeItem('orderID');
        localStorage.setItem('partnerID', partner.partnerID);
        setShowPartnerChange(false);
        setTimeout(() => history.push('/'), 200);
    };

    return (
        <>
            <ul id="UserNav">
                <Dropdown>
                    <Dropdown.Toggle variant="link" style={{color: 'white'}} id="dropdown-basic" drop="left">
                        {currentPartner.name}
                    </Dropdown.Toggle>
                    <Dropdown.Menu alignRight>
                        <Dropdown.Item as="li">
                            <NavLink exact to="/settings" style={{ textDecoration: 'none' }}>{t('user_nav.my_settings')}</NavLink>
                        </Dropdown.Item>
                        <Dropdown.Item as="li">
                            <NavLink exact to="/settings/organization" style={{ textDecoration: 'none' }}>{t('user_nav.organization')}</NavLink>
                        </Dropdown.Item>
                        <Dropdown.Item as="li">
                            <Button
                                variant="link"
                                style={{ padding: 0, color: '#333', fontWeight: 'normal', textDecoration: 'none' }}
                                onClick={_openPartnerChangeModal}
                            >
                                {currentPartner.name} <IoMdArrowDropdown />
                            </Button>
                        </Dropdown.Item>
                        <Dropdown.Item style={{ cursor: 'pointer' }} as="li" onClick={_openLanguageChangeModal}>
                            {language.toUpperCase()} <IoMdArrowDropdown />
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item style={{ cursor: 'pointer' }} as="a" onClick={_handleLogout}>
                            {t('user_nav.logout')}
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </ul>

            <PartnerChangeModal
                show={showPartnerChange}
                onHide={() => setShowPartnerChange(false)}
                currentPartner={currentPartner}
                userPartners={userPartners}
                onPartnerChange={_onPartnerClick}
            />
            
            <LanguageChangeModal
                show={showLanguageChange}
                onHide={() => setShowLanguageChange(false)}
            />
        </>
    )
}

export default UserNav;